export default __webpack_public_path__ + "static/media/KOD0104-min.f180cd08.webp";